const COUNTRIES = [
    { countryCode: 'ae', value: '+971', zhTW: '阿拉伯聯合大公國', enUS: 'United Arab Emirates' },
    { countryCode: 'af', value: '+93', zhTW: '阿富汗', enUS: 'Afghanistan' },
    { countryCode: 'ag', value: '+1268', zhTW: '安地卡及巴布達', enUS: 'Antigua and Barbuda' },
    { countryCode: 'ai', value: '+1264', zhTW: '安圭拉', enUS: 'Anguilla' },
    { countryCode: 'ar', value: '+54', zhTW: '阿根廷', enUS: 'Argentina' },
    { countryCode: 'at', value: '+43', zhTW: '奧地利', enUS: 'Austria' },
    { countryCode: 'au', value: '+61', zhTW: '澳洲', enUS: 'Australia' },
    { countryCode: 'aw', value: '+297', zhTW: '阿魯巴', enUS: 'Aruba' },
    { countryCode: 'bd', value: '+880', zhTW: '孟加拉', enUS: 'Bangladesh' },
    { countryCode: 'be', value: '+32', zhTW: '比利時', enUS: 'Belgium' },
    { countryCode: 'bh', value: '+973', zhTW: '巴林', enUS: 'Bahrain' },
    { countryCode: 'bm', value: '+1441', zhTW: '百慕達', enUS: 'Bermuda' },
    { countryCode: 'bo', value: '+591', zhTW: '玻利維亞', enUS: 'Bolivia' },
    { countryCode: 'br', value: '+55', zhTW: '巴西', enUS: 'Brazil' },
    { countryCode: 'bt', value: '+975', zhTW: '不丹', enUS: 'Bhutan' },
    { countryCode: 'ca', value: '+1', zhTW: '加拿大', enUS: 'Canada' },
    { countryCode: 'cg', value: '+242', zhTW: '剛果共和國', enUS: 'Congo' },
    { countryCode: 'ch', value: '+41', zhTW: '瑞士', enUS: 'Switzerland' },
    { countryCode: 'cm', value: '+237', zhTW: '喀麥隆', enUS: 'Cameroon' },
    { countryCode: 'cn', value: '+86', zhTW: '中國', enUS: 'China' },
    { countryCode: 'co', value: '+57', zhTW: '哥倫比亞', enUS: 'Colombia' },
    { countryCode: 'de', value: '+49', zhTW: '德國', enUS: 'Germany' },
    { countryCode: 'dk', value: '+45', zhTW: '丹麥', enUS: 'Denmark' },
    { countryCode: 'do', value: '+1809', zhTW: '多明尼加', enUS: 'Dominican Republic' },
    { countryCode: 'eg', value: '+20', zhTW: '埃及', enUS: 'Egypt' },
    { countryCode: 'es', value: '+34', zhTW: '西班牙', enUS: 'Spain' },
    { countryCode: 'fi', value: '+358', zhTW: '芬蘭', enUS: 'Finland' },
    { countryCode: 'fj', value: '+679', zhTW: '斐濟', enUS: 'Fiji' },
    { countryCode: 'fr', value: '+33', zhTW: '法國', enUS: 'France' },
    { countryCode: 'gb', value: '+44', zhTW: '英國', enUS: 'United Kingdom' },
    { countryCode: 'gd', value: '+1473', zhTW: '格瑞那達', enUS: 'Grenada' },
    { countryCode: 'ge', value: '+995', zhTW: '喬治亞', enUS: 'Georgia' },
    { countryCode: 'gh', value: '+233', zhTW: '迦納', enUS: 'Ghana' },
    { countryCode: 'gr', value: '+30', zhTW: '希臘', enUS: 'Greece' },
    { countryCode: 'gt', value: '+502', zhTW: '瓜地馬拉', enUS: 'Guatemala' },
    { countryCode: 'gy', value: '+592', zhTW: '蓋亞那', enUS: 'Guyana' },
    { countryCode: 'hk', value: '+852', zhTW: '香港', enUS: 'Hong Kong' },
    { countryCode: 'hn', value: '+504', zhTW: '宏都拉斯', enUS: 'Honduras' },
    { countryCode: 'ht', value: '+509', zhTW: '海地', enUS: 'Haiti' },
    { countryCode: 'id', value: '+62', zhTW: '印尼', enUS: 'Indonesia' },
    { countryCode: 'ie', value: '+353', zhTW: '愛爾蘭', enUS: 'Ireland' },
    { countryCode: 'in', value: '+91', zhTW: '印度', enUS: 'India' },
    { countryCode: 'iq', value: '+964', zhTW: '伊拉克', enUS: 'Iraq' },
    { countryCode: 'is', value: '+354', zhTW: '冰島', enUS: 'Iceland' },
    { countryCode: 'it', value: '+39', zhTW: '義大利', enUS: 'Italy' },
    { countryCode: 'jm', value: '+1876', zhTW: '牙買加', enUS: 'Jamaica' },
    { countryCode: 'jo', value: '+962', zhTW: '約旦', enUS: 'Jordan' },
    { countryCode: 'jp', value: '+81', zhTW: '日本', enUS: 'Japan' },
    { countryCode: 'ke', value: '+254', zhTW: '肯亞', enUS: 'Kenya' },
    { countryCode: 'kh', value: '+855', zhTW: '柬埔寨', enUS: 'Cambodia' },
    { countryCode: 'kr', value: '+82', zhTW: '南韓', enUS: 'South Korea' },
    { countryCode: 'kw', value: '+965', zhTW: '科威特', enUS: 'Kuwait' },
    { countryCode: 'kz', value: '+7', zhTW: '哈薩克', enUS: 'Kazakhstan' },
    { countryCode: 'lc', value: '+1758', zhTW: '聖露西亞', enUS: 'Saint Lucia' },
    { countryCode: 'lk', value: '+94', zhTW: '斯里蘭卡', enUS: 'Sri Lanka' },
    { countryCode: 'lu', value: '+352', zhTW: '盧森堡', enUS: 'Luxembourg' },
    { countryCode: 'ma', value: '+212', zhTW: '摩洛哥', enUS: 'Morocco' },
    { countryCode: 'mg', value: '+261', zhTW: '馬達加斯加', enUS: 'Madagascar' },
    { countryCode: 'mk', value: '+389', zhTW: '北馬其頓', enUS: 'North Macedonia' },
    { countryCode: 'mo', value: '+853', zhTW: '澳門', enUS: 'Macau' },
    { countryCode: 'mv', value: '+960', zhTW: '馬爾地夫', enUS: 'Maldives' },
    { countryCode: 'mx', value: '+52', zhTW: '墨西哥', enUS: 'Mexico' },
    { countryCode: 'my', value: '+60', zhTW: '馬來西亞', enUS: 'Malaysia' },
    { countryCode: 'ng', value: '+234', zhTW: '奈及利亞', enUS: 'Nigeria' },
    { countryCode: 'ni', value: '+505', zhTW: '尼加拉瓜', enUS: 'Nicaragua' },
    { countryCode: 'nl', value: '+31', zhTW: '荷蘭', enUS: 'Netherlands' },
    { countryCode: 'no', value: '+47', zhTW: '挪威', enUS: 'Norway' },
    { countryCode: 'nr', value: '+674', zhTW: '諾魯', enUS: 'Nauru' },
    { countryCode: 'nz', value: '+64', zhTW: '紐西蘭', enUS: 'New Zealand' },
    { countryCode: 'pa', value: '+507', zhTW: '巴拿馬', enUS: 'Panama' },
    { countryCode: 'pg', value: '+675', zhTW: '巴布亞紐幾內亞', enUS: 'Papua New Guinea' },
    { countryCode: 'pk', value: '+92', zhTW: '巴基斯坦', enUS: 'Pakistan' },
    { countryCode: 'pt', value: '+351', zhTW: '葡萄牙', enUS: 'Portugal' },
    { countryCode: 'py', value: '+595', zhTW: '巴拉圭', enUS: 'Paraguay' },
    { countryCode: 'ro', value: '+40', zhTW: '羅馬尼亞', enUS: 'Romania' },
    { countryCode: 'rs', value: '+381', zhTW: '塞爾維亞', enUS: 'Serbia' },
    { countryCode: 'ru', value: '+7', zhTW: '俄羅斯', enUS: 'Russia' },
    { countryCode: 'rw', value: '+250', zhTW: '盧安達', enUS: 'Rwanda' },
    { countryCode: 'sa', value: '+966', zhTW: '沙烏地阿拉伯', enUS: 'Saudi Arabia' },
    { countryCode: 'sc', value: '+248', zhTW: '塞席爾', enUS: 'Seychelles' },
    { countryCode: 'sd', value: '+249', zhTW: '蘇丹', enUS: 'Sudan' },
    { countryCode: 'se', value: '+46', zhTW: '瑞典', enUS: 'Sweden' },
    { countryCode: 'sg', value: '+65', zhTW: '新加坡', enUS: 'Singapore' },
    { countryCode: 'sv', value: '+503', zhTW: '薩爾瓦多', enUS: 'El Salvador' },
    { countryCode: 'sy', value: '+963', zhTW: '敘利亞', enUS: 'Syria' },
    { countryCode: 'th', value: '+66', zhTW: '泰國', enUS: 'Thailand' },
    { countryCode: 'to', value: '+676', zhTW: '東加', enUS: 'Tonga' },
    { countryCode: 'tr', value: '+90', zhTW: '土耳其', enUS: 'Turkey' },
    { countryCode: 'tw', value: '+886', zhTW: '台灣', enUS: 'Taiwan' },
    { countryCode: 'ua', value: '+380', zhTW: '烏克蘭', enUS: 'Ukraine' },
    { countryCode: 'ug', value: '+256', zhTW: '烏干達', enUS: 'Uganda' },
    { countryCode: 'us', value: '+1', zhTW: '美國', enUS: 'United States' },
    { countryCode: 'uy', value: '+598', zhTW: '烏拉圭', enUS: 'Uruguay' },
    { countryCode: 'uz', value: '+998', zhTW: '烏茲別克', enUS: 'Uzbekistan' },
    { countryCode: 've', value: '+58', zhTW: '委內瑞拉', enUS: 'Venezuela' },
    { countryCode: 'vn', value: '+84', zhTW: '越南', enUS: 'Vietnam' },
    { countryCode: 'ye', value: '+967', zhTW: '葉門', enUS: 'Yemen' },
];
// 使用量前 10 名，依訂單量由多到少（見檔頭說明）
const TOP_USAGE = ['tw', 'hk', 'sg', 'mo', 'us', 'cn', 'kr', 'jp', 'au', 'my'];
const dialNumber = (item) => Number(item.value.slice(1));
const topList = TOP_USAGE
    .map((iso) => COUNTRIES.find((item) => item.countryCode === iso))
    .filter((item) => Boolean(item));
const restList = COUNTRIES
    .filter((item) => !TOP_USAGE.includes(item.countryCode))
    .sort((a, b) => dialNumber(a) - dialNumber(b) || a.countryCode.localeCompare(b.countryCode));
const countryCodeList = [...topList, ...restList];
export default countryCodeList;
